import { EntryCollection, Asset } from 'contentful';
import { ProfileLinks } from 'types/TeamMember';

import { getEntries } from './ContentfulClient';

type ContentfulTeamMember = {
  order: number;
  breakerId: number;
  name: string;
  title: string;
  picture: Asset;
  subLine: string;
  blurb: string;
  links: ProfileLinks;
};

const transformTeamMembers = (teamMembers: EntryCollection<ContentfulTeamMember>) => {
  return teamMembers.items.map(({ sys, fields }) => {
    const { breakerId, name, order, title, picture, blurb, links, subLine } = fields;

    return {
      breakerId,
      name,
      order,
      title,
      blurb,
      links,
      subLine,
      id: sys.id,
      imageUrl: picture?.fields?.file?.url || '',
    };
  });
};

export const getAllTeamMembers = async () => {
  return transformTeamMembers(await getEntries<ContentfulTeamMember>('teamMember'));
};
